import create from 'zustand'
import {
  movePuzzleGroup,
  isComplete,
  centerPieces,
  resetPieces
} from '../util'
import { cloneObject } from '../../../shared/utils'

/**
 * Create state store for puzzles
 */
const [usePuzzleStore] = create((set) => ({
  active: null,
  snapRadius: 8,
  showPoints: false,
  setActivePuzzle: (puzzle) => {
    const newPuzzle = cloneObject(puzzle)
    set({
      active: isComplete(newPuzzle)
        ? centerPieces(newPuzzle)
        : newPuzzle
    })
  },
  reset: (active, resetPuzzle) => {
    set({
      active: resetPieces(active, resetPuzzle)
    })
  },
  setSnapRadius: (snapRadius) => set({ snapRadius }),
  moveGroup: (groupId, position) =>
    set((state) => ({
      active: movePuzzleGroup(state, groupId, position)
    }))
}))

export default usePuzzleStore
